import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ArrowSvg } from "./svg/arrow.svg";
function Interaction({
  path,
  type,
  setisError,
  valid,
  Save,
  data,
}: {
  path: number;
  type: "new" | "fix";
  valid: () => boolean;
  setisError: (e: boolean) => void;
  Save: (e: string | undefined) => void;
  data:
    | {
        prjt_id: string;
        prjt_sts_cd: string;
      }
    | {
        ctts_id: string;
      }
    | undefined;
}) {
  const navigate = useNavigate();
  const __next = useCallback(() => {
    document.getElementById("write-project")?.scrollTo(0, 0);
    if (valid()) {
      navigate(`./step/${path + 1}`, { state: data });
    } else {
      setisError(true);
    }
  }, [path, setisError, valid, data]);
  const __back = useCallback(() => {
    if (path !== 1) {
      navigate(`./step/${path - 1}`, {
        state: data,
      });
    }
  }, [path, valid, data]);

  return (
    <div className="interaction">
      {/* {type === "new" ? ( */}
      <button
        className="save"
        onClick={() => {
          Save(undefined);
        }}
      >
        임시저장
      </button>
      {/* ) : undefined} */}
      {path !== 1 ? (
        <button className="back" onClick={__back}>
          <ArrowSvg />
          이전으로
        </button>
      ) : undefined}
      <button className="next" onClick={__next}>
        다음으로
        <ArrowSvg />
      </button>
    </div>
  );
}

export default Interaction;
